
import axiosInstance from "./AxiosInstanceMain";

export const getTasksApi=async(params={})=>{
  const res=await axiosInstance.get( "/tasks", { params } );
  return res.data;
};

export const completeTaskApi=async(id)=>{
  const res=await axiosInstance.put( `/tasks/complete/${id}` );
  return res.data;
};

export const addTaskCommentApi=async(data)=>{
  const res=await axiosInstance.post( "/tasks/comment", data );
  return res.data;
};
